import { GoogleTagManager } from '@next/third-parties/google';

export const GoogleAnalytics = () => {
  const gtmToken = process.env.GTM_TOKEN;

  if (!gtmToken) {
    return null;
  }

  return <GoogleTagManager gtmId={gtmToken} />;
};
